import { render, staticRenderFns } from "./radio.vue?vue&type=template&id=16722aac&"
import script from "./radio.vue?vue&type=script&lang=js&"
export * from "./radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16722aac')) {
      api.createRecord('16722aac', component.options)
    } else {
      api.reload('16722aac', component.options)
    }
    module.hot.accept("./radio.vue?vue&type=template&id=16722aac&", function () {
      api.rerender('16722aac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/form-templates/radio.vue"
export default component.exports